import { difference } from 'lodash/fp';
import getLocalePackIdsForCompletedStreams from './getLocalePackIdsForCompletedStreams';

export default async function getLocalePackIdsForUncompletedStreams(injector, user, streamPackIds) {
    const completedStreamLocalePackIds = await getLocalePackIdsForCompletedStreams(injector, user);
    return difference(streamPackIds, completedStreamLocalePackIds);
}
